import type { RoleValue } from '@giftsay/constants';
import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '../../../store/hooks.js';

export interface ProtectedRouteProps {
  /** Further restricts this route beyond "signed in" (e.g. role assignment: super_admin/admin only). A signed-in user who fails it is sent to "/", which every role that can sign in may see. */
  allowedRoles?: readonly RoleValue[];
}

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { status, user } = useAppSelector((state) => state.auth);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading...
      </div>
    );
  }

  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
